import React, { useState, useRef, useEffect } from "react";
import "../css/cuInputSeprate.css";

const CustomInputSeparate = ({
  separator = "/",
  maxLength = 3,
  fieldCount,
  initialValues,
  onChange,
  inputWidth,
  inputHeight,
  label,
  className,
  unit = "",
}) => {
  const [inputs, setInputs] = useState(
    initialValues || Array(fieldCount).fill("")
  ); // Initialize inputs array with specified count or use provided initial values
  const inputRefs = useRef([]);

  useEffect(() => {
    if (onChange) {
      onChange(combineValues());
    }
  }, [inputs]); // Run useEffect whenever inputs change

  // const handleInputChange = (index, value) => {
  //   // Trim leading zeros
  //   value = value.replace(/^0+/, "");

  //   // Limit the input length to maxLength
  //   if (value.length > maxLength) {
  //     value = value.slice(0, maxLength);
  //   }

  //   const newInputs = [...inputs];
  //   newInputs[index] = value;
  //   setInputs(newInputs);

  //   // Jump to next input field if maxLength is reached
  //   if (value.length === maxLength && index < inputs.length - 1) {
  //     inputRefs.current[index + 1].focus();
  //   }
  // };

  const handleInputChange = (index, value) => {
    // Trim leading zeros
    value = value.replace(/^0+/, "");

    // Convert input to number if it's not empty
    const numericValue = value === "" ? null : parseFloat(value);
    // //("unit --------", unit);
    // Get the selected unit from the CustomDropdown

    // Check if the numeric value exceeds the limit for each vital sign based on the unit
    switch (label.toLowerCase()) {
      case "spo2":
        if (numericValue > 100 || numericValue < 0) return;
        break;
      case "pulse":
        if (numericValue > 480 || numericValue < 0) return;
        break;
      case "bp":
        if (unit.toLowerCase() === "mmhg") {
          // Limit conditions for mmHg unit
          if (index === 0 && (numericValue > 370 || numericValue < 0)) return;
          if (index === 1 && (numericValue > 360 || numericValue < 0)) return;
        } else if (unit.toLowerCase() === "kpa") {
          // Limit conditions for kPa unit (assuming 1 mmHg = 0.133322368 kPa)
          if (index === 0 && (numericValue > 49.3226 || numericValue < 0))
            return;
          if (index === 1 && (numericValue > 47.9969 || numericValue < 0))
            return;
        }
        break;
      case "height":
        // Limit conditions for height based on unit (assuming 272 cm as the limit)
        if (unit.toLowerCase() === "m") {
          if (numericValue > 2.72 || numericValue < 0) return;
        } else if (unit.toLowerCase() === "inch") {
          // Assuming 107 inches as the limit
          if (numericValue > 107 || numericValue < 0) return;
        } else if (unit.toLowerCase() === "cm") {
          if (numericValue > 272 || numericValue < 0) return;
        }
        break;
      case "weight":
        // Assuming 650 kg as the limit
        if (numericValue > 650 || numericValue < 0) return;
        break;
      case "temprature":
        if (unit.toLowerCase() === "c") {
          if (numericValue > 46 || numericValue < 0) return;
        } else if (unit.toLowerCase() === "f") {
          if (numericValue > 111.2 || numericValue < 0) return;
        }
        break;
      default:
        break;
    }

    if (value.length > maxLength) {
      value = value.slice(0, maxLength);
    }

    const newInputs = [...inputs];
    newInputs[index] = value;
    setInputs(newInputs);

    if (value.length === maxLength && index < inputs.length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (event, index) => {
    // Handle backspace
    if (event.key === "Backspace" && inputs[index] === "" && index > 0) {
      const newInputs = [...inputs];
      newInputs[index - 1] = "";
      setInputs(newInputs);
      inputRefs.current[index - 1].focus();
    }
  };

  // Function to combine values with separator
  const combineValues = () => {
    return inputs.join(separator);
  };

  return (
    <div className="cu-seprate-input-main">
      {inputs.slice(0, fieldCount).map(
        (
          value,
          index // Only render input fields up to fieldCount
        ) => (
          <React.Fragment key={index}>
            <input
              type="number"
              value={value}
              placeholder="0"
              onChange={(e) => handleInputChange(index, e.target.value)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              ref={(el) => (inputRefs.current[index] = el)}
              className={`outline-none px-1 text-sm ${className}`}
              style={{ width: inputWidth }}
            />
            {index < fieldCount - 1 && ( // Adjust condition to only render separator if it's not the last field
              <span className="font-bold px-1 text-lg">{separator}</span>
            )}
          </React.Fragment>
        )
      )}
    </div>
  );
};

export default CustomInputSeparate;
